import React from 'react';

// import { useUI } from 'utils/ui';
// import { useRouter } from 'next/router';
import { SliceTypes } from 'providers/prismic/slices';
import { Error } from 'components/error/Error';
import { Slices } from 'containers/slices/Slices';
import { SplitPageLayout } from './SplitPageLayout';
import { SplitPageSection } from './SplitPageSection';

type Props = {
  slices: any;
};

export const SplitPage = ({ slices }: Props) => {
  // const router = useRouter();
  // const ui = useUI();

  if (!slices) {
    return <Error title="Whoops" statusCode={404} />;
  }

  const sections = slices.reduce((prev, slice) => {
    if (slice.type === SliceTypes.SplitPageSection) {
      return [
        ...prev,
        {
          color: slice.color,
          logoColor: slice.logoColor,
          image: slice.image,
          alignment: slice.alignment,
          video: slice.video,
          embed: slice.embed,
          slices: [],
        },
      ];
    }

    if (prev.length === 0) {
      return [
        {
          color: 'white',
          slices: [slice],
        },
      ];
    }

    const lastSection = prev[prev.length - 1];

    if (lastSection && lastSection.slices) {
      lastSection.slices.push(slice);
    }

    return prev;
  }, []);

  // const onClose = () => {
  //   // @ts-ignore
  //   if (!data.linkBack) {
  //     return;
  //   }

  //   // @ts-ignore
  //   const { href, as } = data.linkBack;

  //   // ui.popHistory();
  //   router.push(href, as);
  // };

  return (
    <SplitPageLayout
    // onClose={onClose}
    >
      {sections.map(({ slices, ...rest }, index) => (
        <SplitPageSection key={index} {...rest}>
          <Slices slices={slices} isSplitPage />
        </SplitPageSection>
      ))}
    </SplitPageLayout>
  );
};
